import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { QuickTestimonials } from './components/QuickTestimonials';
import { Problems } from './components/Problems';
import { SystemOverview } from './components/SystemOverview';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { OfferBar } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Comparison } from './components/Comparison';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full bg-ivory font-body text-charcoal" data-id="element-0" data-mp="23vune9yyeqtk">
      <MetaPixel data-id="element-1" data-mp="23t8gmcjw0fce" />
      <main data-id="element-2" data-mp="3ijxokogyjwiu">
        <Hero data-id="element-3" data-mp="3ikh8ubu2yx01" />
        <Stats data-id="element-4" data-mp="3ikqwvtvkeu33" />
        <QuickTestimonials data-id="element-5" data-mp="3ij65ue8glt9z" />
        <Problems data-id="element-6" data-mp="3ihv0wb3a2fha" />
        <SystemOverview data-id="element-7" data-mp="3mlj8uuvtnd32" />
        <Modules data-id="element-8" data-mp="3mkrbpfmkt7ao" />
        <Bonuses data-id="element-9" data-mp="3mk852v2dm5by" />
        <OfferBar data-id="element-10" data-mp="3mjq2zht18ww4" />
        <Pricing data-id="element-11" data-mp="3mj6k9yvk64h1" />
        <Testimonials data-id="element-12" data-mp="3rcj7c4kla37o" />
        <Guarantee data-id="element-13" data-mp="3rdaqgfx028h2" />
        <Faq data-id="element-14" data-mp="3rcsyhvhdegey" />
        <Comparison data-id="element-15" data-mp="3rd189ei755lx" />
        <FinalCta data-id="element-16" data-mp="5yjsutqtdfe" />
      </main>
      <Footer data-id="element-17" data-mp="680tswt8a8y" />
      <PurchasePopup data-id="element-18" data-mp="4n4pyuukj8z" />
    </div>;
}